import {config} from "../../../appContext";

const POPUP_FEATURES = "popup,width=520,height=720";
const MESSAGE_TYPE = "eadm-saml-test";

export class TestLoginSession {
    private active = false;
    private popup: Window | null = null;
    private handler: ((event: MessageEvent) => void) | null = null;
    private watchTimer: number | null = null;
    private timeout: number | null = null;

    constructor(private readonly onResult: (dialogKey: string | null) => void) {}

    start(): Window | "blocked" | "busy" {
        if (this.active) {
            return "busy";
        }
        const popup = window.open("about:blank", "eadm_custom_idp_test", POPUP_FEATURES);
        if (!popup) {
            return "blocked";
        }
        this.active = true;
        this.popup = popup;
        const handler = (event: MessageEvent) => {
            let hubOrigin = "";
            try {
                hubOrigin = new URL(config.getUrlIdentityHub()).origin;
            } catch {
                return;
            }
            if (event.origin !== hubOrigin || event.source !== popup) {
                return;
            }
            const data = event.data as { type?: string, status?: string } | null;
            if (!data || data.type !== MESSAGE_TYPE) {
                return;
            }
            const key = data.status === "ok"
                ? "sso.idp.test.success"
                : data.status === "not_found"
                    ? "sso.idp.test.notfound"
                    : "sso.idp.test.failed";
            this.finish(key);
        };
        this.handler = handler;
        window.addEventListener("message", handler);
        this.watchTimer = window.setInterval(() => {
            if (!popup.closed) {
                return;
            }
            if (this.watchTimer !== null) {
                window.clearInterval(this.watchTimer);
                this.watchTimer = null;
            }
            window.setTimeout(() => {
                if (this.popup === popup) {
                    this.finish("sso.idp.test.closed");
                }
            }, 300);
        }, 500);
        this.timeout = window.setTimeout(() => this.finish("sso.idp.test.closed"), 5 * 60 * 1000);
        return popup;
    }

    navigate(popup: Window, url: string): void {
        if (this.popup !== popup) {
            return;
        }
        popup.location.href = url;
    }

    finish(dialogKey: string | null): void {
        if (!this.active) {
            return;
        }
        this.active = false;
        if (this.handler) {
            window.removeEventListener("message", this.handler);
            this.handler = null;
        }
        if (this.watchTimer !== null) {
            window.clearInterval(this.watchTimer);
            this.watchTimer = null;
        }
        if (this.timeout !== null) {
            window.clearTimeout(this.timeout);
            this.timeout = null;
        }
        const popup = this.popup;
        this.popup = null;
        if (popup && !popup.closed) {
            popup.close();
        }
        this.onResult(dialogKey);
    }
}
